import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

// firebase init
const firebaseConfig = {
    apiKey: 'AIzaSyAc2b9EtVbq88oojWu24aOVZ5dykLOBeRg',
    authDomain: 'applydash.firebaseapp.com',
    databaseURL: 'https://applydash.firebaseio.com',
    projectId: 'applydash',
    storageBucket: 'applydash.appspot.com',
    messagingSenderId: '312925213284',
    appId: '1:312925213284:web:dac55ee3a4aa9fefd1c571'
}
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()

// collection references
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')

// export utils/refs
export {
    db,
    auth,
    usersCollection,
    postsCollection,
    commentsCollection,
    likesCollection
}